/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Errorinvalidcredentials2Inputs */



/**

* @param {_Login_Errorinvalidcredentials2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_errorinvalidcredentials2 = /** @type {((inputs?: _Login_Errorinvalidcredentials2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Errorinvalidcredentials2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("E-Mail/Benutzername oder Passwort ist falsch.")
});
export { _login_errorinvalidcredentials2 as "_login_errorInvalidCredentials" }